var map = {
	"./activityRoom.png": "4b95",
	"./backend.png": "c4a0",
	"./backendIcon.png": "fe0b",
	"./canteen.png": "59d7",
	"./collect.png": "9928",
	"./giveUp.png": "7efe",
	"./giveUpActive.png": "c445",
	"./hotel.png": "4a5d",
	"./icon1.png": "c166",
	"./icon2.png": "0951",
	"./icon3.png": "56ca",
	"./icon4.png": "b451",
	"./icon5.png": "577f",
	"./iconActive1.png": "8c60",
	"./iconActive2.png": "19cb",
	"./iconActive3.png": "30ca",
	"./iconActive4.png": "df4f",
	"./iconActive5.png": "643f",
	"./location/edit.png": "9534",
	"./location/qrcode.png": "0102",
	"./location/umbrella.png": "e02e",
	"./logo.png": "6e81",
	"./photoCasually.png": "bf84",
	"./search.png": "571f",
	"./umbrella.png": "6ade"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6e83";